'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  black: '#000000',
  white: '#ffffff',
  red: {
    base: '#ff0000',
    light: '#fce4d3'
  },
  yellow: '#fff7c9',
  violet: '#e6f0ff',
  turquoise: '#5cc7e1',
  green: {
    base: '#43AE8F',
    light: '#e5eedc',
    success: '#06402B'
  },
  orange: {
    base: '#8A5B00'
  },
  blue: {
    base: '#1496af',
    light: '#30cada',
    lighter: '#bdedf9',
    lighten: '#a4d2db',
    lightness: '#eef8f9',
    dark: '#006880',
    potty: '#f3f9fb',
    gossamer: '#f7fbfc',
    mabel: '#d8f7ff',
    navy: '#1D3B49',
    blue300: '#5588A1',
    blue100: '#4999C0',
    blue500: '#286684',
    blue550: '#0C4D6C',
    tabUnderline: '#086CA5'
  },
  public: {
    gray: '#718E9C'
  },
  sp: {
    black: '#1A1A1A',
    gray: '#666666',
    transparent: 'transparent',
    background: '#FFFFFF',
    colorbase: '#1A1A1A'
  },
  navy: {
    navy400: '#3C6173',
    navy500: '#1D3B49',
    navy600: '#122027',
    navy650: '#142730',
    navy700: '#16242C',
    navy800: '#0E181D'
  },
  gray: {
    base: '#D3D4D9',
    light: '#939393',
    lighter: '#999999',
    lighten: '#d9d9d9',
    sp300: '#B2B2B2',
    sp100: '#E5E5E5',
    sp50: '#F2F2F2',
    sp900: '#1A1A1A',
    sp600: '#666666',
    sp700: '#4D4D4D',
    lightness: '#5f5f5f',
    verylight: '#B5C3CA',
    light300: '#D3D4D9',
    dark: '#2d2d2d',
    darker: '#2f2f2f',
    darken: '#404040',
    gossamer: '#212121',
    neutral: '#292929',
    gray400: '#B5C3CA',
    gray650: '#718E9C'
  },
  silver: {
    base: '#f1f1f1',
    light: '#f7f7f7',
    lighter: '#EEEEEE',
    lighten: '#c7c7c7',
    dark: '#d8d8d8',
    darker: '#454545',
    darken: '#8e8e8e'
  },
  brown: {
    lite: '#555454'
  }
};